import { render, staticRenderFns } from "./DemoTimePickerAllowedTimes.vue?vue&type=template&id=b16cb6fc&"
import script from "./DemoTimePickerAllowedTimes.vue?vue&type=script&lang=js&"
export * from "./DemoTimePickerAllowedTimes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VTimePicker})
